import { ColumnType } from 'antd/es/table'
import columns from '../../UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'

export const strColumns: ColumnType<any>[] = [
  columns[COLUMNS_IDS.hostName],
  columns[COLUMNS_IDS.verifiedName],
  columns[COLUMNS_IDS.tin],
  columns[COLUMNS_IDS.reportStatus],
  columns[COLUMNS_IDS.activeListings],
  columns[COLUMNS_IDS.totalListings],
  { ...columns[COLUMNS_IDS.locations], title: 'Host Location' },
  columns[COLUMNS_IDS.firstActivity],
  columns[COLUMNS_IDS.dataSources],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  strColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
